// Small formatters for the benefits-flow UI. Every monetary figure is an
// estimate (brief §7.6, §12.10) — callers pair these with an "estimated" label.

const GBP = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  maximumFractionDigits: 0,
});

export const gbp = (n: number): string => GBP.format(Math.round(n));

// A benefit's annual value as a range string, or null for non-cash benefits.
export const valueRange = (
  min: number | null,
  max: number | null,
): string | null => {
  if (min === null && max === null) return null;
  const lo = min ?? 0;
  const hi = max ?? min ?? 0;
  if (Math.round(lo) === Math.round(hi)) return `${gbp(hi)}`;
  return `${gbp(lo)}–${gbp(hi)}`;
};
